import { PageLoading } from '@/components/page-loading'
import { Suspense, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { ContentLayout } from '../content-layout'
import { Modal } from 'antd'
import { SignTitle, SvgIcon } from '@/components'

import MailCreate from '@/pages/email/create-task'
import MailTask from '@/pages/email/task-list'
import MailTaskDetail from '@/pages/email/task-detail'
import { t } from '@/i18n'

export const EmailLayout = () => {
  const [isShow, setIsShow] = useState(false)

  const menuList = [
    {
      key: 'create',
      label: t('创建任务'),
      component: <MailCreate />,
    },
    {
      key: 'task',
      label: t('任务列表'),
      component: <MailTask />,
    },
    {
      key: 'task',
      label: t('任务详情'),
      component: <MailTaskDetail />,
      show: false,
      name: 'detail',
    },
  ]

  const onShow = () => {
    setIsShow(true)
  }

  const onHide = () => {
    setIsShow(false)
  }

  const rightSlot = (
    <div
      onClick={() => {
        onShow()
      }}
      className="description"
    >
      <SvgIcon name={'场景描述'} width={14} style={{ marginRight: '6px', height: 14 }} />
      <span>{t('场景描述')}</span>
    </div>
  )

  return (
    <>
      <ContentLayout menuList={menuList} rightSlot={rightSlot}>
        <Suspense fallback={<PageLoading />}>
          <Outlet />
        </Suspense>
      </ContentLayout>
      <Modal
        title={<SignTitle show>{t('场景描述')}</SignTitle>}
        visible={isShow}
        onCancel={onHide}
        footer={null}
        centered
      >
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('可验证设备类型')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          {t('邮件网关、邮件沙箱')}
        </div>
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('验证原理')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          {t(
            '用指定发件服务器向客户端配置的目标邮箱发送包含无害化处理后的样本及真实APT样本的恶意邮件，客户端拉取目标邮件服务器收件信息，评估邮件网关/邮件沙箱产品防御有效性。',
          )}
        </div>
        <div
          className="title"
          style={{
            fontWeight: '500',
            fontSize: '14px',
            color: '#333333',
            marginBottom: '16px',
            marginLeft: '8px',
          }}
        >
          {t('使用说明')}
        </div>
        <div
          className="content"
          style={{
            fontSize: '14px',
            color: '#666666',
            marginBottom: '24px',
            marginLeft: '8px',
          }}
        >
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon
              name={'纸飞机'}
              width={14}
              height={14}
              style={{ marginRight: '6px', minWidth: '14px' }}
            />

            <span>
              {t('创建任务前须部署客户端并配置企业邮箱账号（建议申请独立非个人工作邮箱）。')}
            </span>
          </div>
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon
              name={'纸飞机'}
              width={14}
              height={14}
              style={{ marginRight: '6px', minWidth: '14px' }}
            />

            <span>
              {t(
                '恶意邮件可包含恶意链接和恶意附件，恶意附件使用的是基于真实恶意样本分析提取并重构的无害化样本以及APT真实攻击中截获的恶意样本。',
              )}
            </span>
          </div>
          <div className="item" style={{ display: 'flex', marginBottom: '8px' }}>
            <SvgIcon name={'纸飞机'} width={14} style={{ marginRight: '6px', height: '14px' }} />
            <span>{t('客户端支持自动清除接收邮件（仅支持POP3、Outlook协议邮件）。')}</span>
          </div>
        </div>
      </Modal>
    </>
  )
}
